import clsx from 'clsx'

type LogoProps = {
    variant?: 'default' | 'stacked'
}

export default function Logo({ variant = 'default' }: LogoProps) {
    return (
        <div className='flex justify-center items-center w-full'>
            {variant === 'default' ?
                <img
                    src='/images/Logo One Line.png'
                    alt='Life Rush Logo'
                    className={clsx(
                        'absolute object-contain',
                        '-top-10 w-40 h-40',
                        'stele:w-160 stele:h-160 stele:-top-20'
                    )} />
                :
                <img
                    src='/images/LogoStacked.png'
                    alt='Life Rush Logo'
                    className={clsx(
                        'absolute object-cover',
                        'top-0 w-40 h-40',
                        'stele:w-160 stele:h-160'
                    )}
                />
            }
        </div>
    )
}